import { listOption } from '@/api/base/baseCargoType'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
